import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './lista/lista.js';
import Ficha from './ficha/ficha.js';

function App() {
  return (
    <BrowserRouter >
    {/* <BrowserRouter basename="/extension"> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ficha" element={<Ficha />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
